module.exports = __webpack_public_path__ + "img/facebook.ed2f702.svg";